import platformAppComp from './utils/platformAppComp'
import component from '../../component/component'
import dataModel from '../../dataModel/dataModel'
import type {CompRef, Pointer, PS} from '@wix/document-services-types'
import appControllerUtils from '../../appControllerData/appControllerUtils'

function handleAppWidgetDeletion(ps: PS, widgetRef: Pointer) {
    platformAppComp.removePlatformApplicationFromPageIfLastController(ps, widgetRef)
    platformAppComp.removeControllerFromStateMap(ps, widgetRef)
}

function handleAppWidgetSerialization(ps: PS, controllerRef: Pointer, customStructureData) {
    platformAppComp.addControllerStateToSerializedStructure(ps, controllerRef, customStructureData)
}
function handleAppWidgetParentChange(ps: PS, controllerRef: Pointer, newParentPointer: Pointer) {
    const dataItem = dataModel.getDataItem(ps, controllerRef)
    platformAppComp.removePlatformApplicationFromPageIfLastController(ps, controllerRef)
    platformAppComp.addPlatformAppToPageIfFirstController(
        ps,
        controllerRef,
        appControllerUtils.getControllerAppDefinitionId(dataItem),
        component.getPage(ps, newParentPointer as CompRef)
    )
}

export default {
    handleAppWidgetDeletion,
    handleAppWidgetSerialization,
    handleAppWidgetParentChange
}
